import { DcBaseComponent } from '@deleteagency/dc';
import { deviceObserver } from '@deleteagency/device-observer';
import Flickity from 'flickity';
import constants from '../../../general/js/constants';
import { eventBus } from '../../../general/js/events';
import { IMG_TRIGGER_LIGHTBOX } from './property-carousel-trigger.component';
const DOTS_IN_VIEWPORT = 5;
const AUX_DOTS = 2;
const ANIMATION_TIME = 300; // in ms

export default class PropertyCarouselComponent extends DcBaseComponent {
    static getNamespace() {
        return 'property-car';
    }

    onInit() {
        this.carousel = new Flickity(this.refs.carousel, {
            contain: true,
            setGallerySize: false,
            wrapAround: true,
            pageDots: true,
            resize: true,
            draggable: this.options.hasOwnProperty('draggable') ? this.options.draggable : true,
            arrowShape: constants.CAROUSEL_ARROW_SHAPE,
            on: {
                change: () => {
                    this.updateNumber();
                    this.updateImages();
                },
                dragMove: (event, pointer, moveVector) => {
                    this.animatePageDots(moveVector);
                },
            },
        });
        this.pageDots = this.carousel.pageDots;
        this.isCustomDots = this.pageDots.dots.length > DOTS_IN_VIEWPORT;
        this.updateNumber();
        this.updateImages();
        this.carousel.resize();

        if (this.element.dataset.lightboxImageSet) {
            eventBus.addListener(IMG_TRIGGER_LIGHTBOX, (target, index) => {
                if (target != this.element.dataset.lightboxImageSet) return;

                this.setActiveImage(index);

                // resize once modal is open
                setTimeout(() => {
                    this.carousel.resize();
                }, 100);
            });
            deviceObserver.subscribeOnChange(() => {
                this.carousel.resize();
            });
        }

        if (this.isCustomDots) {
            this.createCustomDots();
        }
        this.direction = null;
    }

    updateNumber = () => {
        this.countText = this.refs.number;
        this.currentSlide = this.carousel.selectedIndex + 1;

        if (!this.countText) return;

        this.countText.textContent = this.currentSlide + '/' + this.carousel.slides.length;
        this.refs.count.classList.add('counted');
        this.refs.count.dataset.dcPropertyCarTrigger = this.carousel.selectedIndex;
    };

    updateImages = () => {
        if (this.refs.secondImage) {
            this.refs.secondImage.innerHTML = this.getNextCell(1);
        }
        if (this.refs.thirdImage) {
            this.refs.thirdImage.innerHTML = this.getNextCell(2);
        }
    };

    animatePageDots = (moveVector) => {
        if (!this.isCustomDots) {
            return;
        }

        const vector = Math.sign(moveVector.x);

        let animationDirect = 'animate-left';

        if (vector < 0) {
            animationDirect = 'animate-right';
        }

        if (this.direction === animationDirect) return;

        this.direction = animationDirect;

        this.customDotElement.classList.add(animationDirect);

        setTimeout(() => {
            this.customDotElement.classList.remove(animationDirect);
            this.direction = null;
        }, ANIMATION_TIME);

        this.prevIndex = this.carousel.selectedIndex;
    };

    createCustomDots = () => {
        const customDotElement = document.createElement('div');
        const dots = document.createElement('ol');
        for (let i = 0; i < DOTS_IN_VIEWPORT + AUX_DOTS; i++) {
            const dot = document.createElement('li');
            dot.classList.add('dot');
            dots.appendChild(dot);
        }
        customDotElement.classList.add('flickity-custom-dots');
        dots.classList.add('flickity-page-dots');
        customDotElement.append(dots);
        this.customDotElement = customDotElement;
        this.refs.carousel.append(customDotElement);
        this.pageDots.holder.remove();
    };

    getNextCell = (step) => {
        const index =
            this.carousel.selectedIndex + step < this.carousel.cells.length
                ? this.carousel.selectedIndex + step
                : this.carousel.selectedIndex + step - this.carousel.cells.length;
        return this.carousel.cells[index].element.innerHTML;
    };

    setActiveImage = (index) => {
        this.carousel.select(index);
        this.prevIndex = index;
    };
}
